import { MAP_STYLES } from "@/constants/map-styles";
import { useStore } from "@/store/store";
import { useCallback } from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../ui/select";

export const MapStyleSelector = () => {
    const mapStyleUrl = useStore(useCallback((state) => state.mapStyleUrl, []));
    const setMapStyleUrl = useStore(useCallback((state) => state.setMapStyleUrl, []));
    const setMapStyle = useStore(useCallback((state) => state.setMapStyle, []));

    const currentStyle = MAP_STYLES.find((style) => style.url === mapStyleUrl);

    return (
        <Select
            value={currentStyle?.url}
            onValueChange={(url) => {
                const style = MAP_STYLES.find((s) => s.url === url);
                if (style) {
                    setMapStyleUrl(style.url);
                    setMapStyle(style.name);
                }
            }}
        >
            <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Select a style" />
            </SelectTrigger>
            <SelectContent>
                {MAP_STYLES.map((style) => (
                    <SelectItem key={style.name} value={style.url}>
                        {style.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}; 